import { render, staticRenderFns } from "./SalesNotestimate.vue?vue&type=template&id=143b4cb4&"
import script from "./SalesNotestimate.vue?vue&type=script&lang=js&"
export * from "./SalesNotestimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports